import { render, staticRenderFns } from "./NotificacionesPage.vue?vue&type=template&id=781f4ee2"
import script from "./NotificacionesPage.vue?vue&type=script&lang=js"
export * from "./NotificacionesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports